
export const addQueryParams = (params) => {

    const queryParams = new URLSearchParams(params).toString()

    return `?${ queryParams }`
}

export const addQueryToUrl = (url, params) => {

    const queryParams = new URLSearchParams(params).toString()

    return `${ url }?${ queryParams }`
}

/**
 * Navigate to a page and reload to get fresh token with updated attributes
 * @param navigate
 * @param url
 */
export const loadPage = (navigate, url) => {

    navigate(url)
    window?.location?.reload()
}